/**
 * Default above-typical soft-warning threshold for a money field. Lives in
 * its own pure-utils file (2026-09-16 Office Inbox "Ledger" redesign) so
 * `extraPriceHintLine.js` and other pure helpers can import it without
 * pulling in `MoneyInput.js` — that component imports `react-intl`, which
 * CRA's Jest cannot transform (it lives in `node_modules` and ships ESM
 * only), so a pure util importing it would fail every suite that imports
 * the util, even transitively.
 *
 * `MoneyInput.js` imports this constant and re-exports it under the same
 * name so its ~20 existing importers (`import { MONEY_SOFT_WARNING_DEFAULT }
 * from '.../MoneyInput'`) stay untouched.
 */
export const MONEY_SOFT_WARNING_DEFAULT = 10000;
